var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTrolley = function SvgTrolley(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1V1C1.63496 1 3.05061 2.13546 3.40546 3.73145L4.08819 6.80209C4.49506 8.63203 6.11822 9.93393 7.99284 9.93393H12.0694",
    stroke: "#7A7A7A",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.24683 2.80176L13.823 2.80176L13.519 4.53362C13.1832 6.44673 11.5216 7.8421 9.57926 7.8421H7.52801C5.61643 7.8421 3.97202 6.48956 3.60318 4.6139L3.24683 2.80176Z",
    stroke: "#7A7A7A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.51361 13.2826C6.02203 13.2826 6.4342 12.8704 6.4342 12.362C6.4342 11.8536 6.02203 11.4414 5.51361 11.4414C5.00518 11.4414 4.59302 11.8536 4.59302 12.362C4.59302 12.8704 5.00518 13.2826 5.51361 13.2826Z",
    stroke: "#7A7A7A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6725 13.2826C12.181 13.2826 12.5931 12.8704 12.5931 12.362C12.5931 11.8536 12.181 11.4414 11.6725 11.4414C11.1641 11.4414 10.752 11.8536 10.752 12.362C10.752 12.8704 11.1641 13.2826 11.6725 13.2826Z",
    stroke: "#7A7A7A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59888 2.79907L7.08769 7.86873",
    stroke: "#7A7A7A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.428 2.79907L9.93917 7.86873",
    stroke: "#7A7A7A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.74756 5.18978L13.4068 5.24025",
    stroke: "#7A7A7A"
  })));
};
export default SvgTrolley;